export default __webpack_public_path__ + "static/media/mamie.9659f3ad.png";